var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResectionRemaining = function SvgResectionRemaining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v18H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.616 7.038a5 5 0 0 0-1.232 0M16.605 10.053a5 5 0 0 0-.616-1.068M15.989 15.015a5 5 0 0 0 .616-1.068M11.384 16.962a5 5 0 0 0 1.232 0M7.395 13.947a5 5 0 0 0 .616 1.068M8.011 8.985a5 5 0 0 0-.616 1.068"
  })));
};
export default SvgResectionRemaining;